export default __webpack_public_path__ + "static/reviewtheroom-27cb34c424eb20409dd3eff63298822c.jpg";